import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, PlusCircle, CreditCard, Shield, Info } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export const Layout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const tabs = [
    { path: '/', icon: Home, label: 'Главная' },
    { path: '/searches', icon: Search, label: 'Поиски' },
    { path: '/add', icon: PlusCircle, label: 'Добавить' },
    { path: '/subscription', icon: CreditCard, label: 'Подписка' },
    { path: '/info', icon: Info, label: 'Инфо' },
  ];

  if (user?.is_admin) {
    tabs.push({ path: '/admin', icon: Shield, label: 'Админ' });
  }

  return (
    <div style={styles.container}>
      <main style={styles.main}>
        <Outlet />
      </main>

      <nav style={styles.tabBar}>
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path || ((tab.path === '/admin' || tab.path === '/info') && location.pathname.startsWith(tab.path));
          const Icon = tab.icon;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              style={{
                ...styles.tab,
                color: isActive ? 'var(--tg-theme-button-color, #2481cc)' : 'var(--tg-theme-hint-color, #999)',
              }}
            >
              <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
              <span style={styles.tabLabel}>{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--tg-theme-bg-color, #f5f5f5)',
    paddingBottom: '64px',
  },
  main: {
    flex: 1,
    overflowY: 'auto',
  },
  tabBar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '64px',
    backgroundColor: 'var(--tg-theme-secondary-bg-color, #fff)',
    borderTop: '1px solid var(--tg-theme-hint-color, #e0e0e0)',
    zIndex: 100,
    paddingBottom: 'env(safe-area-inset-bottom, 0)',
  },
  tab: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    background: 'none',
    border: 'none',
    padding: '8px 12px',
    fontSize: '11px',
    cursor: 'pointer',
    flex: 1,
    transition: 'color 0.2s',
  },
  tabLabel: {
    fontSize: '10px',
    fontWeight: 500,
  },
};

export default Layout;
